import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { CardMedia, Container, IconButton, Stack, Typography } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import Link from '@mui/material/Link';
import { StyledDivider } from '../component/Typography/TypographyComponent';

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: '#fff',
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
	...theme.applyStyles('dark', {
		backgroundColor: '#1A2027',
	}),
}));

const navLinks: { url: string; name: string }[] = [
	{
		url: '/',
		name: 'Home',
	},
	{
		url: '/about-us',
		name: 'About Us',
	},
	{
		url: '/meny',
		name: 'Menu',
	},
	{
		url: '/gallery',
		name: 'Gallery',
	},
	{
		url: '/contactus',
		name: 'Contact Us',
	},
];

const Footer = () => (
	<Box sx={{ flexGrow: 1 }}>
		<div
			style={{
				backgroundColor: '#FFF8F6',
				width: '100%',
				height: 'auto',
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
			}}
		>
			<Container
				maxWidth="lg"
				className="p-2"
				style={{ position: 'relative', overflowX: 'hidden' }}
			>
				<Grid container spacing={2}>
					<Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
						<Item sx={{ background: 'none', boxShadow: 'none' }}>
							<Typography color="primary" variant="h4" textAlign={'start'}>
								About Catering
							</Typography>
							<StyledDivider />
							<Typography
								textAlign="start"
								// color="secondary"
								// variant="subtitle2"
								variant="body1"
								className="letter-animation"
								sx={{
									fontFamily: 'Montserrat',
									color: '#515151',
									fontSize: '12px',
									fontWeight: '700',
								}}
							>
								At Chakaravarthy catering, we make your celebration and every
								occasion memorable with our flavors. We provide delicious food on
								time, cater to every demand, and value service, taste, and style to
								make perfect wedding events and outdoor caterings. We have vast
								experience for the past 43 years.
							</Typography>
							<Stack direction="row" spacing={1} sx={{ alignItems: 'center', mt: 2 }}>
								<Link
									href="https://www.instagram.com/chakaravarthycatering/?hl=en"
									target="_blank"
									rel="noopener noreferrer"
								>
									<IconButton aria-label="instagram" size="small">
										<InstagramIcon />
									</IconButton>
								</Link>
								<Link
									href="https://www.youtube.com/channel/UCK1w1Smj9cpsf05NXZ92kSg"
									target="_blank"
									rel="noopener noreferrer"
								>
									<IconButton aria-label="youtube" size="small">
										<YouTubeIcon />
									</IconButton>
								</Link>
								<Link
									href="https://www.facebook.com/chakravarthycatering"
									target="_blank"
									rel="noopener noreferrer"
								>
									<IconButton aria-label="facebook" size="small">
										<FacebookIcon />
									</IconButton>
								</Link>
								<Link
									href="https://x.com/Chakaravarthyc1"
									target="_blank"
									rel="noopener noreferrer"
								>
									<IconButton aria-label="twitter" size="small">
										<TwitterIcon />
									</IconButton>
								</Link>
							</Stack>
						</Item>
					</Grid>
					<Grid size={{ xs: 12, sm: 6, md: 2, lg: 2 }}>
						<Item sx={{ background: 'none', boxShadow: 'none' }}>
							<Typography color="primary" variant="h4" textAlign={'start'}>
								Quick Links
							</Typography>
							<StyledDivider />

							{navLinks.map((val) => (
								<Typography
									variant="subtitle2"
									textAlign="start"
									key={val.name}
									className="mb-2"
								>
									<Link
										href={val.url}
										rel="noopener"
										underline="none"
										color="secondary"
										className="underline-link"
									>
										{val.name}
									</Link>{' '}
								</Typography>
							))}
						</Item>
					</Grid>
					<Grid size={{ xs: 12, sm: 6, md: 3, lg: 3 }}>
						<Item sx={{ background: 'none', boxShadow: 'none' }}>
							<Typography color="primary" variant="h4" textAlign={'start'}>
								Contact Us
							</Typography>
							<StyledDivider />
							<div className="contact-info" style={{ fontSize: '16px' }}>
								<Typography className="text-start mb-2" display={'flex'}>
									<div className="me-2">
										<LocationOnOutlinedIcon color="primary" />
									</div>
									{/* <Typography color="secondary" variant="subtitle2">
										Avadi / Thiruninravur / Redhills
									</Typography> */}
									<Typography color="secondary" variant="subtitle2">
										<a
											href="https://maps.app.goo.gl/GNo9Fe4YoCDgiXDy7"
											style={{ textDecoration: 'none', color: 'inherit' }}
										>
											Avadi
										</a>{' '}
										/{' '}
										<a
											href="https://maps.app.goo.gl/aFkyTRWNkgq2mY59A"
											style={{ textDecoration: 'none', color: 'inherit' }}
										>
											Thiruninravur
										</a>{' '}
										/{' '}
										{/* <a
											href="/location/redhills"
											style={{ textDecoration: 'none', color: 'inherit' }}
										> */}
										Redhills
										{/* </a> */}
									</Typography>
								</Typography>
								<Typography display={'flex'} className="mb-2">
									<EmailOutlinedIcon color="primary" className="me-2" />
									<Typography color="secondary" variant="subtitle2">
										<Link
											href="mailto:chakaravarthycatering@gmail.com"
											rel="noopener"
											underline="none"
											color="secondary"
										>
											chakaravarthycatering@gmail.com
										</Link>
									</Typography>
								</Typography>
								<Typography display={'flex'} className="mb-2">
									<CallOutlinedIcon color="primary" className="me-2" />
									<Typography
										textAlign={'start'}
										color="secondary"
										variant="subtitle2"
									>
										<Link
											href="tel:9500066066"
											rel="noopener"
											underline="none"
											color="secondary"
										>
											(+91) 9500066066
										</Link>
										<span> / </span>
										<Link
											href="tel:9884433383"
											rel="noopener"
											underline="none"
											color="secondary"
										>
											9884433383
										</Link>
									</Typography>
								</Typography>
								<Typography display={'flex'} className="mb-2">
									<AccessTimeIcon color="primary" className="me-2" />
									<Typography variant="subtitle2">
										<Link rel="noopener" underline="none" color="secondary">
											24/7 Hours Service
										</Link>
									</Typography>
								</Typography>
							</div>
						</Item>
					</Grid>

					<Grid size={{ xs: 12, sm: 6, md: 3, lg: 3 }}>
						<Item sx={{ background: 'none', boxShadow: 'none' }}>
							<Typography color="primary" variant="h4" textAlign={'start'}>
								Social Gallery
							</Typography>
							<StyledDivider />
							<Grid container spacing={1}>
								{[...Array(6)].map((_, index) => (
									<Grid size={{ xs: 4 }} key={index}>
										<CardMedia
											component="img"
											image={`/social-gallary/${index + 1}.webp`}
											alt={`Gallery ${index + 1}`}
											sx={{
												width: '100%',
												height: '75px',
												objectFit: 'cover',
											}}
										/>
									</Grid>
								))}
							</Grid>
						</Item>
					</Grid>
				</Grid>
			</Container>
		</div>
	</Box>
);

export default Footer;
